__turbopack_context__.v({
  "fadeIn": "gBod4G_fadeIn",
  "loadingContainer": "gBod4G_loadingContainer",
  "loadingText": "gBod4G_loadingText",
  "logoContainer": "gBod4G_logoContainer",
  "pulse": "gBod4G_pulse",
});
